import React, { FC } from 'react'
import { connect } from 'react-redux'
import { ccpaSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { LegalContents, FooterColumn } from '@chegg-wt/core/types/core'
import { LvpMarginWrapper } from '../Layouts/LargeVideoPlayerLayout'
import * as Styled from './styled'
import { FooterColumns } from './FooterColumns'
import { LegalNode } from './LegalNode'

export interface FooterProps {
  footerLinkColumns: FooterColumn[]
  legalContents: LegalContents
  ccpa: boolean
}

export const Footer: FC<FooterProps> = ({ footerLinkColumns, legalContents, ccpa }) => (
  <Styled.FooterContentsContainer>
    <LvpMarginWrapper>
      <Styled.ColumnContainer>
        <Styled.Wrapper>
          <FooterColumns columns={footerLinkColumns} ccpa={ccpa} />
        </Styled.Wrapper>
      </Styled.ColumnContainer>
      <LegalNode contents={legalContents} />
    </LvpMarginWrapper>
  </Styled.FooterContentsContainer>
)

const mapStateToProps = (state) => ({
  ccpa: ccpaSelector(state),
})

export default connect(mapStateToProps)(Footer)
